// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3KwIr","notes":"Notes_notes__35hsM","note":"Notes_note__2PiGh","markdown":"Notes_markdown__2jeSS"};